import React from 'react'
import { Link } from 'react-router-dom'
import '../signupcategory/SignupCategory.css'

const SignupCategory = () => {
  return (
    <div className='login-section w-100 '>
        <Link rel='stylesheet' to="/signup" className='back-btn'>Back</Link>
      <div className='login-box d-flex flex-wrap align-content-center justify-content-center'>
        <div className='login-form w-100'>
            <div className=' btn-box w-100'>
                <Link rel='stylesheet' to="/subscription" className='btn btn-border text-center w-100 d-block'>Sign up as a Customer</Link>
                <Link rel='stylesheet' to="/subscription" className='btn btn-border text-center w-100 d-block'>Sign up as a Sugar Daddy</Link>
                <Link rel='stylesheet' to="/subscription" className='btn btn-border text-center w-100 d-block'>Sign up as a Worker</Link>
            </div>
        </div>
      </div>
    </div>
  )
}

export default SignupCategory
